import { type ReactNode } from 'react';
import { Group, Text } from '@mantine/core';
import { PiInfo } from 'react-icons/pi';

/**
 * A slim, left-aligned helper line — the lightweight replacement for a
 * full-width `Alert`. Constrained to `maw={720}` so a one-sentence note never
 * spans the whole content width (UX-012). Reusable for any inline helper copy.
 */
export default function SectionBanner({
  children,
  icon = <PiInfo size={14} />,
  color = 'dimmed',
  maw = 720,
}: {
  children: ReactNode;
  icon?: ReactNode;
  color?: string;
  maw?: number;
}) {
  return (
    <Group gap={6} align="flex-start" wrap="nowrap" maw={maw}>
      <Text c={color} mt={1} style={{ lineHeight: 0 }}>
        {icon}
      </Text>
      <Text fz="xs" c={color}>
        {children}
      </Text>
    </Group>
  );
}
